module.exports = __webpack_public_path__ + "img/brain-white-logo.1659967e.png";